import { Chip, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../../../Primitives";
import { KvixThemeVariantContext } from "../../../theme";
const useStyles = makeStyles((theme) => ({
    root: {
        padding: "8px 8px 7px 8px",
        fontWeight: 500,
        width: "calc(100% - 16px)",
        [theme.breakpoints.down("xs")]: {
            padding: `${6 / 1.3}px ${8 / 1.3}px ${7 / 1.3}px ${8 / 1.3}px`,
            width: `calc(100% - ${(8 / 1.3) * 2}px)`
        }
    },
    metaRow: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            marginTop: 6
        }
    },
    descriptionRow: {
        fontWeight: 600
    },
    metaChip: {
        "&.MuiChip-root": {
            background: theme.palette.background.paper,
            borderRadius: 6,
            paddingLeft: "6px",
            paddingRight: "6px",
            cursor: "pointer",
            userSelect: "none",
            height: 22,
            marginRight: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& .MuiChip-label": {
                paddingLeft: "0px",
                paddingRight: "0px",
                fontSize: 12,
                fontWeight: 600
            }
        },
        "&.withIcon": {
            "&.MuiChip-root": {
                flexDirection: "row-reverse",
                "& .MuiChip-icon": {
                    marginLeft: -6,
                    marginRight: 5,
                    width: "0.7em",
                    height: "0.7em"
                }
            },
            "&.lessMargin": {
                "&.MuiChip-root": {
                    "& .MuiChip-icon": {
                        marginLeft: -9,
                        marginRight: 2
                    }
                }
            }
        }
    }
}));
export const CardMeta = (props) => {
    const { duration, filterByChip, language, description } = props;
    const { variant } = useContext(KvixThemeVariantContext);
    const isDarkMode = variant === "dark";
    const classes = useStyles(Object.assign(Object.assign({}, props), { isDarkMode }));
    const { t, ready } = useTranslation("language");
    if (!ready) {
        return null;
    }
    return (React.createElement("div", { className: classes.root },
        (duration || language) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.metaRow },
                React.createElement(Chip, { label: t(language), className: classes.metaChip, onClick: () => filterByChip("language", language) }),
                duration && (React.createElement(Chip, { label: `${duration} min`, className: classes.metaChip, onClick: () => filterByChip("duration", duration) }))))),
        description && (React.createElement("div", { className: classes.descriptionRow },
            React.createElement(Text, { variant: "h5" }, description)))));
};
//# sourceMappingURL=CardMeta.js.map